/**
 * Ad Performance shell API client.
 *
 * The dashboard itself is served whole by the admin backend at
 * /api/ads/embed (data inlined, server-rendered headline and KPIs), so this
 * client only covers the shell: the published-snapshot strip and the stored
 * HTML of a snapshot.
 */

import { BriefingListItem, BriefingRecord, fetchBriefing, fetchBriefingList } from '../briefing/api';
import { AdsView, buildHash } from './hashState';

export type AdsSnapshot = BriefingListItem;
export type AdsSnapshotRecord = BriefingRecord;

/** The live dashboard, framed by the shell. */
export function embedUrl(view: AdsView): string {
  return `/api/ads/embed?range=${encodeURIComponent(view.range)}&channel=${encodeURIComponent(view.channel)}#${buildHash(view)}`;
}

/** Tuesday and Friday publishes, newest first. */
export function fetchSnapshots(limit = 30): Promise<AdsSnapshot[]> {
  return fetchBriefingList('ads', limit);
}

export function fetchSnapshot(id: string): Promise<AdsSnapshotRecord> {
  return fetchBriefing(id);
}

export { formatBriefingDate as formatSnapshotDate } from '../briefing/api';
